import { render, staticRenderFns } from "./ImportPrestataires.vue?vue&type=template&id=81620846&scoped=true"
import script from "./ImportPrestataires.vue?vue&type=script&lang=js"
export * from "./ImportPrestataires.vue?vue&type=script&lang=js"
import style0 from "./ImportPrestataires.vue?vue&type=style&index=0&id=81620846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81620846",
  null
  
)

export default component.exports